export const baseURL =import.meta.env.VITE_DOMAIN_NAME_FRONT_END+"/v1/"
export const exceptThisSymbols = ['e', 'E', '+', '-', '.',''];
export const branchLiveKey =import.meta.env.REACT_APP_BRANCH_LIVE_KEY
export const CDN = import.meta.env.REACT_APP_CDN;
export const rumStage = import.meta.env.VITE_DOMAIN_NAME_FRONT_END
